function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { includes, map, join } from 'lodash';
var ImageResizer = /*#__PURE__*/function () {
  function ImageResizer() {
    var _this = this;
    _classCallCheck(this, ImageResizer);
    _defineProperty(this, "imageGeneratorDomain", 'img-gen.pitchero.com');
    // Domains pointed at the image resizer
    _defineProperty(this, "resizerDomains", ['img-res.pitchero.com', 'img-res.pitchero-staging.com', 'd2dzjyo4yc2sta.cloudfront.net', 'image-resizer-682510251.eu-west-1.elb.amazonaws.com', 'resizer.pitchero.com']);
    // Non pitchero.com domains that are accepted by the image resizer
    _defineProperty(this, "externalResizableDomains", ['d3itj9t5jzykfd.cloudfront.net', 'img.youtube.com', 'cdn.filepicker.io']);
    _defineProperty(this, "excludedResizableFiles", ['spacer.gif']);
    _defineProperty(this, "resizeUrl", function (url, transformation) {
      if (_this.isPlaceholder(url)) {
        var w = transformation.w,
          h = transformation.h;
        return _this.resizePlaceholderImage(url, w, h);
      }
      if (!_this.isResizableImage(url)) {
        return url;
      }
      var baseUrl = _this.baseUrl(url);
      var params = _objectSpread({
        url: _this.stripProtocol(baseUrl)
      }, transformation);
      var encodedParams = map(params, function (value, key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
      });
      return "https://img-res.pitchero.com/?".concat(join(encodedParams, '&'));
    });
    _defineProperty(this, "resizePlaceholderImage", function (url, width, height) {
      if (!_this.isPlaceholder(url)) {
        return _this.resizeUrl(url, {
          w: width,
          h: height,
          t: 'square'
        });
      }
      var queryString = url.lastIndexOf('?') === -1 ? '' : url.substr(url.lastIndexOf('?'));
      var path = url.substr(0, url.lastIndexOf('/'));
      return "".concat(path, "/").concat(width, "x").concat(height, ".jpg").concat(queryString);
    });
    _defineProperty(this, "getFullSizeSrc", function (url) {
      var hostname = _this.getHostname(url);
      if (!_this.isResizerDomain(hostname)) {
        // URL provided is not from the resizer so return as is
        return url;
      }
      var baseUrl = _this.getBaseUrlFromResizerUrl(url);
      return baseUrl || url;
    });
    _defineProperty(this, "getHostname", function (url) {
      var hostname;
      // find & remove protocol (http, ftp, etc.) and get hostname

      if (url.indexOf('//') > -1) {
        var _url$split = url.split('/'),
          _url$split2 = _slicedToArray(_url$split, 3),
          host = _url$split2[2];
        hostname = host;
      } else {
        var _url$split3 = url.split('/'),
          _url$split4 = _slicedToArray(_url$split3, 1),
          _host = _url$split4[0];
        hostname = _host;
      }

      // find & remove port number
      var _hostname$split = hostname.split(':'),
        _hostname$split2 = _slicedToArray(_hostname$split, 1),
        hostWithoutPort = _hostname$split2[0];
      hostname = hostWithoutPort;

      // find & remove "?"
      var _hostname$split3 = hostname.split('?'),
        _hostname$split4 = _slicedToArray(_hostname$split3, 1),
        hostWithoutQueryString = _hostname$split4[0];
      hostname = hostWithoutQueryString;
      return hostname;
    });
    _defineProperty(this, "isPitcheroDomain", function (hostname) {
      return hostname.endsWith('.pitchero.com') && hostname !== _this.imageGeneratorDomain;
    });
    _defineProperty(this, "isPlaceholder", function (url) {
      return url.startsWith("https://".concat(_this.imageGeneratorDomain, "/team/placeholder")) || url.startsWith("https://".concat(_this.imageGeneratorDomain, "/club/placeholder"));
    });
    _defineProperty(this, "stripProtocol", function (url) {
      return url.replace(/(^\w+:|^)\/\//, '');
    });
    _defineProperty(this, "getBaseUrlFromResizerUrl", function (resizerUrl) {
      var regex = new RegExp('[?&]url(=([^&#]*)|&|#|$)');
      var results = regex.exec(resizerUrl);
      if (!results || !results[2]) {
        return null;
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    });
  }
  return _createClass(ImageResizer, [{
    key: "isResizableImage",
    value: function isResizableImage(url) {
      var hostname = this.getHostname(url);
      if (this.isResizerDomain(hostname)) {
        return this.getBaseUrlFromResizerUrl(url) !== null;
      }
      if (!this.isResizableFile(url)) {
        return false;
      }
      return this.isPlaceholder(url) || this.isResizableDomain(hostname);
    }
  }, {
    key: "isResizableFile",
    value: function isResizableFile(url) {
      return !this.excludedResizableFiles.some(function (excludedFile) {
        return url.includes(excludedFile);
      });
    }
  }, {
    key: "isResizableDomain",
    value: function isResizableDomain(hostname) {
      return this.isPitcheroDomain(hostname) || includes(this.externalResizableDomains, hostname);
    }
  }, {
    key: "isResizerDomain",
    value: function isResizerDomain(hostname) {
      return includes(this.resizerDomains, hostname);
    }
  }, {
    key: "baseUrl",
    value: function baseUrl(url) {
      var hostname = this.getHostname(url);
      if (!this.isResizerDomain(hostname)) {
        return url;
      }
      return this.getBaseUrlFromResizerUrl(url);
    }
  }]);
}();
export default new ImageResizer();